var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaWinnerBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 426.384,
    height: 74.964,
    viewBox: "0 0 426.384 74.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_18386",
    "data-name": "Group 18386",
    transform: "translate(-1368.616 -382.362)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18379",
    "data-name": "Group 18379",
    transform: "translate(1368.616 382.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97589",
    "data-name": "Path 97589",
    d: "M826.486,456.65H457.532l-28.715-37.479,28.715-37.485H826.486L855.2,419.168Z",
    transform: "translate(-428.817 -381.686)",
    fill: "#a50012"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_97590",
    "data-name": "Path 97590",
    transform: "translate(943.14 2.817)",
    fill: "red",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 816.6023559570312 446.5654296875 L 460.6126708984375 446.5654296875 L 437.7424621582031 417.0291137695312 L 460.6126708984375 387.4880981445312 L 816.6023559570312 387.4880981445312 L 839.4725952148438 417.0267028808594 L 816.6023559570312 446.5654296875 Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 816.1118774414062 445.5654602050781 L 838.2079467773438 417.0266723632812 L 816.1118774414062 388.4880676269531 L 461.1031494140625 388.4880676269531 L 439.007080078125 417.0291137695312 L 461.10302734375 445.5654602050781 L 816.1118774414062 445.5654602050781 M 817.0927734375 447.5654602050781 L 460.1222229003906 447.5654602050781 L 436.4777221679688 417.0291748046875 L 460.1222229003906 386.4880676269531 L 817.0927734375 386.4880676269531 L 840.7373046875 417.0266723632812 L 817.0927734375 447.5654602050781 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaWinnerBackground);
export default __webpack_public_path__ + "static/media/mega-winner-background.31f5e9bd7d4e3622eca436219f715dc9.svg";
export { ForwardRef as ReactComponent };